import { Switch, SwitchProps as MaterailSwitchProps } from '@material-ui/core'
import React from 'react'

type CheckboxProps = MaterailSwitchProps & {
  value?: boolean
}

const CheckBox = (props: CheckboxProps) => {
  const { checked, value, ...rest } = props
  return <Switch checked={value} {...rest} />
}

export default CheckBox
